/* eslint-disable dot-notation */
/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable no-debugger */
/* eslint-disable prefer-template */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable spaced-comment */
/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
// eslint-disable-next-line prefer-destructuring

import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Grid } from "@material-ui/core";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CustomTab, Button } from "../../atomicComponents";
import {
  CustomFormGroup,
CustomDatePickerFinancial
} from "../../components/FormComponents";
import {
  MESSAGE_TYPE,
} from "../../constants";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./LinkageAccess.module.css";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import Truckloading from "../../components/CvLoader/Cvloader"; 
import MultiSelects from "../../components/FormComponents/MultiSelects";
import { setLogin } from '../../redux/features/auth/actions';
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";


const LinkageAccess = () => {
  const history = useHistory();
  const dispatchNew= useDispatch();
  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };
  const { showPopup ,isPopupOpen} = usePopupManager();
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedBu, setSelectedBu] = useState([]);;
  const [selectedProject, setSelectedProject] = useState([]);
  const[maxDate,setMaxDate]=useState(null)
  const auth = useSelector((state) => state.auth);
  const [loading, setLoading] = React.useState(false)
  let { 
    personNumber,
    companyCode,
    userRole,
  } = auth;
  const [selectedBarrel, setSelectedBarrel] = useState([]);
  const [BCList, setBCList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [buList, setBuList] = useState([]);
  const [subBU, setSubBu] = useState([]);
  const [BCSelected, setBCSelected] = useState([]);
  const [barrelList, setBarrelList] = useState([]);
  const [tempBarrelList, setTempBarrelList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [projectInfo, setProjectInfo] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedPersonNo, setSelectedPersonNo] = useState([]);
  
  useEffect(() => {
    if(selectedEmployees !== null) {
    if (selectedEmployees.length != 0 ) {
      const selectedEmployeesPersonNo = selectedEmployees.map(
        (employee) => employee.value
      );
      setSelectedPersonNo(selectedEmployeesPersonNo);
    }}
  }, [selectedEmployees]);
  const baseURL = useSelector((state) => state.counter.baseUrl);
  const [modifiedData, setModifiedData] = useState([]);
  const [finalData, setFinalData] = useState([]);
const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
  function getFinancialYearLastDate(strDocDate) {
    const docDate = moment(strDocDate, "YYYY-MM-DD"); // Parse the input date using moment

    let startYear;
    let endYear;
    if (docDate.month() + 1 <= 3) {
      startYear = docDate.year() - 1;
      endYear = docDate.year();
    } else {
      startYear = docDate.year();
      endYear = docDate.year() + 1;
    }
    let endDate = moment(strDocDate).add(1, 'years').format('YYYY-MM-DD');
    let getmaxDate = moment(strDocDate).add(1, 'years').format('YYYY-MM-DD');

   setMaxDate(getmaxDate)

    return endDate; // Return the calculated end date
  }

  const [defaultDate, setDefaultDate] = useState(null);

  useEffect(() => {
    const currentDate = moment().format("YYYY-MM-DD");
        const financialYearLastDate = getFinancialYearLastDate(currentDate);
    setDefaultDate(financialYearLastDate);
  }, []);

  useEffect(() => {
    setSelectedProject([]);
    setSelectedBarrel([]);
    setSelectedEmployees([]);
    setSelectedProjectsDetails('');
  },[BCSelected])
  
  useEffect(() => {
    setSelectedProject([]);
    setSelectedProjectsDetails('');
  },[selectedBarrel])

  const handleStartDateChange = (momentDate, index) => {
    const updatedModifiedData = [...modifiedData];

    if (index >= 0 && index < updatedModifiedData.length) {
      const formattedDate = momentDate.format("YYYY-MM-DD");
      const endDate = moment(formattedDate).add(90, "days").format("YYYY-MM-DD");
      updatedModifiedData[index].startDate = formattedDate;
      const endDate1 = getFinancialYearLastDate(formattedDate);
      updatedModifiedData[index].startDate = formattedDate;
      setModifiedData(updatedModifiedData);
      updatedModifiedData[index].endDate = moment(endDate).format("YYYY-MM-DD");
      updatedModifiedData[index].maxDate = moment(endDate1).format("YYYY-MM-DD");
      setModifiedData(updatedModifiedData);
          }
  };

  const handleEndDateChange = (momentDate, index) => {
    const formattedDate = momentDate.format("YYYY-MM-DD");
    const updatedModifiedData = [...modifiedData];

    if (index >= 0 && index < updatedModifiedData.length) {
      updatedModifiedData[index].endDate = formattedDate;
      setModifiedData(updatedModifiedData);
    }
      };

  const getCityBCList = () => {
    setLoading(true)
    const data = {
      roleid: userRole,
      co_code: sanitizeCoCodeNumeric(companyCode),
      pers_no: sanitizeNumeric(personNumber),
    };

    axios
      .post(`${baseURL}master/getCityBCList/`, data,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))    
        let res=response.data
        if(res.msg == "Success"){
          setLoading(false)
        const transformedData = res.data.map((item) => ({
          label: item.description,
          value: item.code_codefull,
        }));
        setLoading(false) 
        setBCList(transformedData);  
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
 
        } 
        else if(res.msg ==="Fail"){
          setLoading(false)       
        }
      }).catch((error) => {
        setLoading(false)
        console.log(error.response.status, 'error.response.status')
          dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
          if (error.response?.status == 403) {
            console.log(error.response.status, 'error.response.status')
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
            return error.response.data;
          }
         

        
      });
  };

  useEffect(() => {
    getCityBCList();
  }, []);

  const SpLinkageAccessBcEmployee = () => {
    try{
  
      let values = null;
      if (BCSelected !== null) { 
      values = BCSelected.map((item) => item.value);
      const joinedValues = values.join(",");
      const d = {
        strc: joinedValues,
        co_code: sanitizeCoCodeNumeric(companyCode),
      };
      axios.post(`${baseURL}master/SpLinkageAccessBcEmployee/`, d,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      }).then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let res=response.data
        if(res.msg === "Success" ){
          setLoading(false)
          const transformed_subbu_list = res.data[0].SubBu_List.map((item) => ({
            label: item.subbu_code,
            value: item.subbu_desc,
          }));
          const transformed_bu_list = res.data[0].BU_List.map((item) => ({
            label: item.bu_code,
            value: item.bu_desc,
          }));
          const transformed_employee_data = res.data[0].employee_list.map(
            (item) => ({
              label: item.empl_name,
              value: item.pers_no,
            })
          );
          setEmployeeList(transformed_employee_data);
          setBuList(transformed_bu_list);
          setSubBu(transformed_subbu_list);   
          dispatchNew(setLogin({...auth, recentStatus: response.status}))

        } 
        else if(res.msg==="Fail"){
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: res.data,
          });
        }
      
      }).catch((error) => {
      dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
      if (error.response?.status === 403) {
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        return error.response.data;
      }
    });
  }
      else{
        setSelectedBarrel([]);
        setSelectedEmployees([]);
        setEmployeeList([]);
        setBuList([]);
        setSubBu([]);
      }

    }
    catch(error){
      setLoading(false)      
      if (error.response?.status===403){
        dispatchNew(setLogin({...auth, recentStatus: error.response.status}))
        return error.response.data;

      }
      
    }
  };

  useEffect(() => {
    SpLinkageAccessBcEmployee();
  }, [BCSelected]);
  const 
  handleEmployeeChange = (option) => {
    setSelectedEmployees(option)
    if (option === null){
      setSelectedBarrel([]);
      setBarrelList([]);
    }else{
      setBarrelList(tempBarrelList)
    }
  }
 

  const barrelInfo = () => {

    try { 
      let pers_role = ''
      if(userRole.includes('SA')){
        pers_role = 'SA'
      }else if(userRole.includes('LI')){
        pers_role = 'LI'
      }
      const selected_bc = BCSelected.map(item => item.value);
      const data = {
        co_code: sanitizeCoCodeNumeric(companyCode),
        pers_no: sanitizeNumeric(personNumber),
        pers_role,
        selected_bc
      };
      axios.post(`${baseURL}master/barrelInfo/`,data,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      }).then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let res=response.data
        if(res.msg === "Success" ){
          setLoading(false)   
        const transformedBarrel = res.data.map((item) => ({
          label: item.description,
          value: item.code_code,
        }));
        setTempBarrelList(transformedBarrel);
        setBarrelList(transformedBarrel);
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
         } 
        else if(res.msg ==="Fail"){
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: res.data,
          });
        }
      })
    } catch (error) {
      setLoading(false)     
      console.error(error.response.status,'error.res.status');
      dispatchNew(setLogin({ ...auth, recentStatus: error.res.status }));
      if (error.res?.status === 403) {
        console.error(error.response.status,'error.res.status');
        dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
        return error.response.data;
      }    
    }
  };

  
  useEffect(() => {
    if(BCSelected !== null && BCSelected.length > 0) {
        barrelInfo();
    }else{
      setSelectedBarrel([])
      setSelectedEmployees([])
      setBarrelList([])
    }
  }, [BCSelected]);
  const spLinkageFilterSearch = () => { 
    const barrel = selectedBarrel.map((item) => item.value);
    const joinedBarrel = barrel.join(",");
    const Bc = BCSelected.map((item) => item.value);
    const joinedBc = Bc.join(",");
    const d = {
      persno: sanitizeNumeric(personNumber),
      barrelcode: joinedBarrel,
      strbc: joinedBc,
    };
    axios
      .post(`${baseURL}master/sp_linkagefiltersearch/`, d,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      })   
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let res=response.data
        if(res.msg === "Success" ){
        setLoading(false)
        setProjectInfo(res.data);
        const transformedProject = res.data.map((item) => ({
          label: item.project,
          value: item.project_def,
        }));
        setProjectList(transformedProject);
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
      } 
        else if(res.msg ==="Fail"){
          setLoading(false)
         showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info:res.data,
        });
        }
      
     
      }).catch((error) => {
        setLoading(false)      
          dispatchNew(setLogin({ ...auth, recentStatus: error.res.status }));
          if (error.response?.status === 403) {
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
            return error.response.data;
          }        
      });
  };

  useEffect(() => {
    if(selectedBarrel !== null) {
      if (selectedBarrel.length > 0) {
        spLinkageFilterSearch();
    }}
  }, [selectedBarrel]);

  const handleVehicleClick = () => {
    if (setSelectedBu.length > 0) {
      spLinkageFilterSearch();
    } 
  };

  const handleCancelClick = () => {
    window.location.reload();
  };

  const [commaSeparatedSelectedProject, setCommaSeparatedSelectedProject] =
    useState("");

  useEffect(() => {
    if(selectedProject !== null) {
    if (selectedProject?.length > 0) {
      const Project = selectedProject?.map((item) => item.value);
      const joinedProject = Project.join(",");
      setCommaSeparatedSelectedProject(joinedProject);
    }
  else{
    setCommaSeparatedSelectedProject([]);
    setSelectedProjectsDetails([]);
  }}
  }, [selectedProject]);

  const [selectedProjectsDetails, setSelectedProjectsDetails] = useState([]);

  useEffect(() => {
    if (commaSeparatedSelectedProject.length > 0) {
      const filteredProjects = projectInfo.filter((project) =>
        commaSeparatedSelectedProject.includes(project.project_def)
      );
      setSelectedProjectsDetails(filteredProjects);
    }
  }, [commaSeparatedSelectedProject]);

  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxChange = (event, index) => {
    const { checked } = event.target;
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  };

  const updateFinalData = () => {
    
    setFinalData(modifiedData);
  };

  useEffect(() => {
      updateFinalData(); 
  }, [modifiedData]);

  const [dataDB, setDataDB] = useState([]);

  useEffect(() => {
    let pers_role = ''
      if(userRole.includes('SA')){
        pers_role = 'SA'
      }else if(userRole.includes('LI')){
        pers_role = 'LI'
      }
    if (selectedPersonNo.length !== 0 && finalData.length !== 0) {
      const resultList = selectedPersonNo.flatMap((i_pers_no) =>
        finalData.map((projectData) => ({
          i_pers_no:sanitizeNumeric( i_pers_no.toString()),
          proj_def: projectData.project_def,
          proj_desc: projectData.project,
          i_ins_by: personNumber,
          i_role: pers_role,
          start_date: projectData.startDate,
          end_date: projectData.endDate,
          hrs:projectData.hrs === "" ? null : projectData.hrs,
        }))
      );
      setDataDB(resultList);
    }
  }, [selectedPersonNo, finalData]);

  const handleSelectedProjectsChange = (newSelectedProjects) => {
    const currentDate = moment().format("YYYY-MM-DD");
    const financialYearLastDate1 = getFinancialYearLastDate(currentDate);
    const formattedFinancialYearLastDate = moment().add(90, 'days').format("YYYY-MM-DD");
    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
      startDate: currentDate,
      endDate: formattedFinancialYearLastDate,
      maxDate: financialYearLastDate1,
      hrs: item.hrs || "",
    }));

    setModifiedData(newModifiedData);
  };

  useEffect(() => {
    if (selectedProjectsDetails.length > 0) {
      handleSelectedProjectsChange(selectedProjectsDetails);

    }
  }, [selectedProjectsDetails]);

  const saveButton = () => {
      let errorParamsList = []
      finalData.map((obj, index) => {     
        let errorParams = {}
        const startDateObject = moment(obj.startDate, 'YYYY-MM-DD');
        const endDateObject = moment(obj.endDate, 'YYYY-MM-DD');
  
          if ( endDateObject  >= startDateObject) {
            // setIsValid(true);
            // console.log(startDateObject, 'obj.effective_date')
          }
          else {
            errorParams["date"] = `${errorParams?.date}`
            if (Object.keys(errorParams).length > 0) {
              errorParams["project"] = obj.project_def
              errorParamsList.push(errorParams)
            }
          }  
      })
     
      if (errorParamsList.length > 0) {
        let msg = ""
        let msg2=[]
        errorParamsList.map((obj) => {
          msg = msg + " For " + obj["project"] + " - "
          msg2.push(` For ` + obj["project"] +  `- End Date Should be greater Than Start Date,`)
          Object.keys(obj).map((key) => {
         
            if (key == "date") {
              msg += `End Date Should be greater Than Start Date,`
            }
          
          })
        }
        )
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
         
          dataTable:msg2
        })
        errorParamsList = []
        msg = ""
      }
   
      else {
        setLoading(true)
        axios
        .post(`${baseURL}master/linkageaccessSave`, dataDB,{
          headers: {
          'Content-Type': 'application/json',
          },
          withCredentials:true
        })
        .then((res) => {
          dispatchNew(setLogin({...auth, recentStatus: res.status}))
          if (res.data.msg === "Success") {
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: res.data.data,
              reloads: true, // Set reload to true or false based on your condition
            });
            setLoading(false)          
            
          } else {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Please provide valid data.",
            });
          }
        })
        .catch((error) => {
          console.log(error,'error')
          setLoading(false)
          dispatchNew(setLogin({ ...auth, recentStatus: error.res.status }));
          if (error.response?.status == 403) {
            console.log(error.response.status, 'error.response.status')
            dispatchNew(setLogin({ ...auth, recentStatus: error.response.status }));
            return error.response.data;
          }          
        });
      
      }
      
  };

  useEffect(() =>{
    renderBCInfo()
  },[BCSelected, selectedEmployees,selectedBarrel, selectedProjects])

  const renderBCInfo = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={6} lg={6} xs={6}> 
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>BC Information</span>
            </div>
            <div className={styles.formDiv}>
             
                    <MultiSelects
                      className={clsx(styles.select, styles.sel2)}
                      isMulti
                      isClearable
                      value={BCSelected}
                      options={BCList}
                      onChange={(selectedOption) => {
                        setBCSelected(selectedOption);
                      }}
                      hasSelectAll={false}
                      name="Project_def"
                    /> 
            </div>
          </div>
        </Grid>      
        <Grid item md={6} lg={6}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Employees</span>
            </div>
            <div className={styles.formDiv}>          
               <MultiSelects
                 width="460px"
                      className={clsx(styles.select, styles.sel2)}
                      isMulti
                      isClearable
                      value={selectedEmployees}
                      options={employeeList}
                      onChange={(selectedOption) => {
                        handleEmployeeChange(selectedOption);
                      }}
                      hasSelectAll={false}                     
                      name="city"      
                    /> 
            </div>
          </div>
        </Grid>

        <Grid item md={6} lg={6}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Barrel</span>
            </div>
            <div className={styles.formDiv}>
             
                <MultiSelects
                  width="460px"
                      className={clsx(styles.select, styles.sel2)}
                      isMulti
                      isClearable
                      value={selectedBarrel}
                      options={barrelList}
                      onChange={(selectedOption) => setSelectedBarrel(selectedOption)}
                      hasSelectAll={false}
                      name="barrel"
                
                    /> 
            </div>
          </div>
        </Grid>

        <Grid item md={6} lg={6}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Projects</span>
            </div>
            <div className={styles.formDiv}>            
                <MultiSelects
                      width="460px"
                      className={clsx(styles.select, styles.sel2)}
                      isMulti
                      isClearable
                      value={selectedProject}
                      options={projectList}
                      onChange={(selectedOption) =>
                       setSelectedProject(selectedOption)
                      }
                      hasSelectAll={true}                   
                      name="barrel"                
                    /> 
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
  useEffect(()=>{
    if(modifiedData?.length){
      getCurrentFiscalYearExtend(modifiedData)
    }
  },[modifiedData])

  function getCurrentFiscalYearExtend(datas) {
     if(datas){
       datas.map((data,index)=>{
       var startYear = "";
       var endYear = "";   
       var dateStr = data.startDate       ;
       var currentDate = moment(dateStr, "YYYY-MM-DD");
       var month = Number(currentDate.format("MM"));
       var date = Number(currentDate.format("DD"));
       var year = Number(currentDate.format("YYYY"));
       if (month <= 3) {
       
 
           startYear = year - 1;
           endYear = year;
       } else {
           startYear = year;
           endYear = year + 1;
          
       }
        let endDate = addDays(currentDate, 365);
        let getmaxDate = addDays(currentDate, 365);
        setMaxDate(getmaxDate);
     })
   }
 }
 
 const disableFutureYears = (date) => {
  const year = date.getFullYear();
  return year !== 2024 && year !== 2025;
};
  const renderProjectTable = () => (
    <div className={styles.formGroup}>
      <>
        <Grid
          container
          spacing={1}         
          style={{ marginTop: "10px" }}
          columns={12}
        >
          <Grid item md={12} lg={12} xs={12}>
            <TableSimple
              tableColumnData={selectedProjectsDetails.map((info, index) => ({           
                projectNo: info.project_def,
                projectDesc: info.project,
                startDate: (
                  <CustomDatePickerFinancial                  
                    inputProps={{
                      className: clsx(styles.select, styles.dateInput),
                    }}
                    autoOk
                    clearable                 
                    inputVariant="outlined"                   
                    value={modifiedData[index]?.startDate || info?.startDate}                
                   onChange={(e) => handleStartDateChange(e, index)}
                    emptyLabel="DD-MM-YYYY"            
                    format="DD-MM-YYYY"
                    data-testid="date-picker-div-1"
                    style={{ width: "100%" }}
                    minDate={new Date()}
                    maxDate={modifiedData[index]?.maxDate}
                  />
                ),
                endDate: (
                  <CustomDatePickerFinancial                  
                    inputProps={{
                      className: clsx(styles.select, styles.dateInput),
                    }}
                    autoOk
                    clearable                 
                    inputVariant="outlined"             
                    value={modifiedData[index]?.endDate || info?.endDate}                   
                    onChange={(e) => handleEndDateChange(e, index)}
                    emptyLabel="DD-MM-YYYY"                  
                    format="DD-MM-YYYY"
                    data-testid="date-picker-div-1"
                    style={{ width: "100%" }}
                    minDate={new Date()}
                    maxDate={modifiedData[index]?.maxDate}                  
                  />
                ),              
              }))}
              tableHeaderLabel={[             
                "Project No_120",
                "Project Description_460",
                "Start Date_115",
                "End Date_115",            
              ]}
              TableRowHederAling="start"
              size="small"
              headerColor="#E6F2FF"
              className="custom-table"
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          className={styles.myGrid}
          style={{ marginTop: "10px", justifyContent: "center" }}
          columns={12}
        >        
          <Grid item md={6} lg={7} sm={12}>
            <div className={styles.rowDiv}>
              <div className={styles.formDiv}>
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton
                  )}
                  variant="primary"
                  disabled={selectedEmployees === null || selectedEmployees?.length === 0}
                  data-testid="confirm-action"
                  style={{ marginRight: "5px", display: "flex" }}
                  onClick={saveButton}
                >
                  Save
                </Button>

                <Button
                  className={clsx(styles.actionButton, styles.resetButton)}
                  variant="tertiary"            
                  onClick={handleCancelClick}
                  data-testid="confirm-action"
                  style={{ marginLeft: "30px" }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    </div>
  );
  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>     
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Project Linkage" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel />
          </div>       
          </div>    
      
        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >        
          <>
            <CustomFormGroup header="Linkage Access" body={renderBCInfo()} />         
            {selectedProjectsDetails.length > 0  ? renderProjectTable() : null}         
          </>       
        </div>
        {loading==true ? 
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"10px",background:"white", boxShadow:"0px 3px 6px #00000027"}}>
               <Truckloading />
            </div>:''}   
      </div>
    </>
  );
};

export default LinkageAccess;